import resume from '../assets/JYF_Resume.pdf';

export default {resume};